<template>
    <div class="border-b border-gray-200 py-1"></div>
</template>
